import { NoteEditOutlineIcon } from './NoteEditOutlineIcon';

/**
 * author: Colton Wiscombe
 * id DD82356F-AF1D-4A08-A740-880F31AE563D
 * name note-edit-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-edit-outline.svg
 * tags
 * - Edit / Modify 
 */
export const PostItNoteEditOutlineIcon = NoteEditOutlineIcon;
export default PostItNoteEditOutlineIcon